import {
  SkeletonLoader,
  Paginator,
  DataTable,
  FilterBar,
  PageActions,
  ExportButton,
} from 'components';

import { humanReadable } from 'utils';
import { HistoryLogsProps, HistoryLog } from './HistoryLogs.types';
import columns from './columns';

import './history-logs.scss';

function TypeBodyTemplate(row: HistoryLog) {
  return (
    <span
      className={`colored-circle colored-circle--${row.type.toLowerCase()}`}
    >
      {row.type}
    </span>
  );
}

function dateBodyTemplate(field: string) {
  return function (row: HistoryLog) {
    if (row[field as keyof HistoryLog])
      return humanReadable(row[field as keyof HistoryLog] as string);

    return 'N/A';
  };
}

export default function HistoryLogsUi({
  isLoading,
  isExporting,
  totalRecords,
  listNumber,
  filter,
  options,
  data,
  handlers,
}: HistoryLogsProps) {
  return (
    <div className="history-logs">
      <PageActions>
        <ExportButton
          disabled={isLoading || !data.logs || data.logs.length === 0}
          onClick={handlers.handleDownload}
          loading={isExporting}
        />
      </PageActions>

      <FilterBar
        loading={isLoading}
        onReset={handlers.handleFilterClear}
        search={{
          inputs: [
            {
              name: 'employeeId',
              placeholder: 'Employee ID',
              value: filter.employeeId || '',
            },
          ],
          onChange: handlers.handleSearchChange,
          onSubmit: handlers.handleSubmitSearch,
          width: 4,
        }}
        filters={[
          {
            kind: 'dropdown',
            name: 'list',
            required: true,
            label: 'List',
            placeholder: 'Select list',
            value: listNumber,
            options: options.listNumber,
            onChange: handlers.handleListNumberChange,
          },
          {
            kind: 'date',
            label: 'Date range',
            value: filter.dates,
            onChange: handlers.handleDateChange,
          },
        ]}
      />

      {isLoading ? (
        <SkeletonLoader height="4.4rem" width="8rem" />
      ) : (
        <DataTable
          sortMode="multiple"
          totalRecords={totalRecords}
          onRowClick={handlers.handleRowClick}
          value={data.logs}
          columns={columns.map((column) => {
            if (column.field === 'type') {
              return {
                ...column,
                body: TypeBodyTemplate,
              };
            }

            if (
              column.field === 'createdDate' ||
              column.field === 'updatedDate'
            ) {
              return {
                ...column,
                body: dateBodyTemplate(column.field),
              };
            }

            return column;
          })}
        />
      )}

      {data.logs.length > 0 &&
        (isLoading ? (
          <SkeletonLoader height="3rem" width="40rem" />
        ) : (
          <Paginator
            first={filter.first}
            rows={filter.rows}
            totalRecords={totalRecords}
            rowsPerPageOptions={[10, 50, 100]}
            onPageChange={handlers.handlePageChange}
          />
        ))}
    </div>
  );
}
